import { MatDialog } from '@angular/material/dialog';
import { firstValueFrom } from 'rxjs';
import {
  ConfirmationDialog,
  DialogData,
} from '../app/shared/confirmation-dialog/confirmation.component';

export function getBookingConfirmationThroughDialog(
  dialog: MatDialog,
  dialogId: string,
  text: string,
  title?: string,
): Promise<string | undefined> {
  const dialogData: DialogData = {
    id: dialogId,
    text,
    title,
  };

  const dialogRef = dialog.open(ConfirmationDialog, {
    data: dialogData,
  });

  return firstValueFrom(dialogRef.afterClosed());
}
